import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
    typography: {
        button: {
            textTransform: 'none'
        }
    }
});